import { HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllNomenclaturesFromEntityUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllNomenclaturesFromEntity
  implements GetAllNomenclaturesFromEntityUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllNomenclaturesFromEntityUseCaseInterface.Params,
  ): Promise<GetAllNomenclaturesFromEntityUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: generateUrl(this.url, params),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
